var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowDownSolid = function SvgArrowDownSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.102 15.004-3.5 3.5a.866.866 0 0 1-.63.246.866.866 0 0 1-.628-.246l-3.473-3.5a.843.843 0 0 1 0-1.23.843.843 0 0 1 1.23 0l2.024 1.996V6.938a.47.47 0 0 0-.438-.438H7.626a.864.864 0 0 1-.875-.875c0-.465.383-.875.875-.875h3.063c1.203 0 2.187.984 2.187 2.188v8.832l1.996-1.997a.843.843 0 0 1 1.23 0 .843.843 0 0 1 0 1.23Z"
  })));
};

export default SvgArrowDownSolid;